<style lang="less" scoped>
  @import '../vars.less';

  .material-status {
    display: inline;
  }
  .label,
  .dot {
    display: inline-block;
    vertical-align: middle;
  }

  .dot {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 100%;
    background-color: @success-color;
    margin-left: @space-medium;
  }
  .dot.color-0 {
    background-color: transparent;
  }
  .dot.color-1 {
    background-color: @success-color;
  }
  .dot.color-2 {
    background-color: @danger-color;
  }
  .dot.color-3 {
    background-color: @warning-color;
  }
  .dot.color-4 {
    background-color: @text-color-secondary;
  }
</style>

<template>
  <div class="material-status">
    <span v-if="value != 0" class="label">{{ $t('物料状态') }}:</span>
    <div  class="dot" :class="'color-' + value" />
  </div>
</template>

<script>
export default {
  name: 'material-status',
  props: {
    // 取值：
    // 0：忽略库存；
    // 1：绿灯【库存数量大于等于订货数量】；
    // 2：红灯【零库存】；
    // 3：黄灯【库存数量小于订货数量】；
    // 4：灰灯【发货完成】
    value: Number
  }
}
</script>
